import { StoredAuthData } from '@/types/types';
import { openDB } from 'idb';

export class IndexDB {
  private static async getUserData() {
    try {
      const db = await openDB('firebaseLocalStorageDb');
      const allAuthData = (await db.getAll('firebaseLocalStorage')) as StoredAuthData[];
      const userData = allAuthData.find((data) => typeof data.value === 'object');
      if (!userData || typeof userData.value !== 'object') return undefined;
      db.close();
      return userData;
    } catch (e) {
      return undefined;
    }
  }

  static async getUserEmail() {
    const data = await IndexDB.getUserData();
    return data?.value.email;
  }
  static async getUserId() {
    const userData = await IndexDB.getUserData();
    return userData?.value.uid;
  }

  static async isUserAuthenticated() {
    const userData = await IndexDB.getUserData();
    return !!userData;
  }

  static async isEmailVerified() {
    const userData = await IndexDB.getUserData();
    return userData?.value.emailVerified;
  }
}
